import { render, staticRenderFns } from "./_base-loading.vue?vue&type=template&id=1268bd42&"
import script from "./_base-loading.vue?vue&type=script&lang=js&"
export * from "./_base-loading.vue?vue&type=script&lang=js&"
import style0 from "./_base-loading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports